import { FormikProps, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { getAddAiPromptFormValidation } from './FormikData';
import { FormikValues } from 'formik/dist/types';
import { IAiPrompt } from '../../../../types/interfaces/ai-prompt';
import { usePostPutAiPrompt } from '../../../../services/redux/api/appConfigApi';

export function useAddAiPromptComponent(
  onClose: () => void,
  aiPrompt?: IAiPrompt,
) {
  const { t } = useTranslation();
  const [postPutAiPrompt, { isLoading }] = usePostPutAiPrompt();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddAiPromptFormValidation(t),
    initialValues: {
      key: aiPrompt?.key || '',
      value: aiPrompt?.value || '',
    },
    onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutAiPrompt({
      id: aiPrompt?.id,
      body: {
        key: values.key,
        value: values.value,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return {
    formik,
    isLoading,
  };
}
